import { PersonsList, Title, Wrapper } from './ourHrTeam.styles';
import { IOurHrTeam } from './interfaces';
import { Person } from './Person/Person';

export const OurHrTeam = ({ titleAs, title, team }: IOurHrTeam) => {
  return (
    <Wrapper>
      <Title as={titleAs}>{title}</Title>
      <PersonsList>
        {team.map((item, index) => {
          return <Person key={index} {...item} />;
        })}
      </PersonsList>
    </Wrapper>
  );
};
